$(document).ready(function() {
    // --- Configuration & Selectors ---
    const SETTINGS = {
        urls: {
            add: (id) => `/api/basket/add/${id}`,
            remove: (id) => `/api/basket/remove/${id}`, // Decrease qty
            delete: (id) => `/api/basket/delete/${id}`,  // Full delete
            reorder: (id) => `/api/orders/${id}/re-order`
        },
        selectors: {
            countHolder: '#js-basket-line-count',
            countHolder2: '.summary_row.sub_total .left span',
            cartTotal: '.cart .cart_inner .bottom .cart_summary .js-basket_sub_total',
            cartContainer: '.cart .cart_inner .products'
        }
    };

    // --- Utilities ---
    const Utils = {
        parseInt: (str) => {
            const num = parseInt(String(str).replace(/[^0-9-]/g, ''), 10);
            return isNaN(num) ? 0 : num;
        },
        parseFloat: (str) => {
            const num = parseFloat(String(str).replace(/,/g, ''));
            return isNaN(num) ? 0.00 : num;
        },
        formatMoney: (num) => num.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        
        getProductDetails: ($el) => {
            // 1. Find the parent container 
            // We look for .product_card, .product, OR any element with the data-attribute directly
            let $card = $el.closest('.product_card, .product, .wish-product, [data-product-id]'); 
            
            // Fallback for Hero: If we are in product_hero but $card didn't get the ID
            if (!$card.data('product-id')) {
                $card = $el.closest('section').find('[data-product-id]').first();
            }
        
            // 2. Identify the pricing blocks
            const $priceBlock = $card.find('.pricing, .product_price').first();
            
            // 3. Extract Normal Price
            const $normalContainer = $priceBlock.find('.normal_price');
            const rawNormalPrice = $normalContainer.find('.price').text() || $priceBlock.find('.price').first().text();
            
            // 4. Extract Offer Price
            const $offerContainer = $priceBlock.find('.offer_price, .offer');
            let rawOfferPrice = "0";
            if ($offerContainer.length > 0) {
                rawOfferPrice = $offerContainer.find('.price').text();
            }
        
            // 5. Currency & Title Logic
            const currencyText = $priceBlock.find('.currency').first().text().trim();
            
            // Look for h1 (Hero) or .product_title (Grid)
            let title = $card.find('h1, .product_title').first().text().trim();
            if (!title) {
                title = $card.find('h4').not('.price, .currency').first().text().trim();
            }
        
            // 6. Qty Logic
            const qtyText = $card.find('.product-qty-in-cart, .js-add-product-qty, .default_qty').first().text();
            const qtyTextFormatted = qtyText.replace(/[a-zA-Z]/g, '').trim();

            // 7. Product Type
            const productType =  $card.find('.product_data').attr('data-type');
            const productIncVal = parseFloat($card.find('.product_data').attr('data-inc-qty')).toFixed(2) || 1;
                
            return {
                id: $card.data('product-id'), 
                img: $card.find('img').first().attr('src'),
                title: title, 
                currency: currencyText,
                price: Utils.parseFloat(rawOfferPrice) > 0 ? Utils.parseFloat(rawOfferPrice) : Utils.parseFloat(rawNormalPrice),
                normalPrice: Utils.parseFloat(rawNormalPrice),
                offerPrice: Utils.parseFloat(rawOfferPrice),
                currentQty: qtyTextFormatted,
                element: $card,
                productType: productType,
                productIncVal: productIncVal
            };
        }
    };

    // --- UI Updaters ---

    // 1. Update Global Counters (Header badge & Total Price)
    const updateGlobalTotals = (totalPrice, uniqueLinesCount) => {
        // Update Count (Unique items / num_lines)
        const $count = $(SETTINGS.selectors.countHolder);
        const $count2 = $(SETTINGS.selectors.countHolder2);
        $count.html(uniqueLinesCount);
        if($count2.length > 0) $count2.html(uniqueLinesCount + ' Items');
    
        // Update Total Price (Directly from server)
        const $total = $(SETTINGS.selectors.cartTotal);
        $total.html(Utils.formatMoney(totalPrice));
    };

    // 2. Synchronize all instances of this product (Grid, Slider, Cart)
    const syncProductState = (productId, newQty, product_type) => {
        // UPDATED: Selector to find all instances, including wishlist (.wish-product)
        const $allInstances = $(`
            .product_card[data-product-id="${productId}"], 
            .product[data-product-id="${productId}"], 
            .product_hero[data-product-id="${productId}"],
            .wish-product[data-product-id="${productId}"]
        `);
        
        $allInstances.each(function() {
            const $el = $(this);
            
            // Context Check
            const isInsideCart = $el.closest('.cart_inner').length > 0;
            // 1. Always update text counters (Hero, Cart, Grid, Wishlist)
            // UPDATED: Added .js-add-product-qty to selector
            const qtyText = product_type === 'kg' ? `${parseFloat(newQty).toFixed(2)} KG` : newQty;
            $el.find('.product-qty-in-cart, .default_qty, .js-add-product-qty').text(qtyText);
            
            // 2. Handle 'in_cart' class
            if (newQty > 0) $el.addClass('in_cart');
            else $el.removeClass('in_cart');

            // 3. BADGE LOGIC 
            if (!isInsideCart) {
                // Determine container (Wishlist often doesn't have .image_holder in the same way, so we check)
                const $badgeContainer = $el.find('.product_image .image_holder, .product_image a').first();
                let $badge = $el.find('.cart_qty');
                
                if (newQty > 0) {
                    if ($badge.length === 0) {
                        // Only append if container exists (prevents errors on different layouts)
                        if($badgeContainer.length > 0) {
                            $badgeContainer.append(`<div class="cart_qty">${product_type === 'kg' ? parseFloat(newQty).toFixed(2): newQty}</div>`);
                        }
                    } else {
                        $badge.text(product_type === 'kg' ? parseFloat(newQty).toFixed(2): newQty);
                    }
                } else {
                    $badge.remove();
                }
            } else {
                $el.find('.cart_qty').remove();
            }
        });
    };

    // 3. Add Item HTML to Cart Sidepanel
    const renderCartItem = (product) => {
        // Prevent duplicates
        if ($(`.cart_inner .product[data-product-id="${product.id}"]`).length > 0) return;

        // Note: I added 'js-cart-action' class and 'data-action' attributes 
        // to your specific HTML structure so the JS still works.
        const html = `
            <div class="product in_cart" data-product-id="${product.id}">
                <div class="product_image">
                    <div class="image_holder">
                        <img src="${product.img}" alt="${product.title}">
                    </div>
                </div>
                <div class="product_details">
                    <h4>${product.title}</h4>
                    <div class="pricing">
                        ${product.offerPrice > 0 ? `
                            <p class="offer_price">
                                <span class="currency">${product.currency}</span> 
                                <span class="price">${Utils.formatMoney(product.offerPrice)}</span>
                            </p>
                        `: ''}
                        <p class="normal_price">
                            <span class="currency">${product.currency}</span> 
                            <span class="price">${Utils.formatMoney(product.normalPrice)}</span>
                        </p>
                    </div>
                </div>
                <div class="product_qty">
                    <span class="default_qty">
                        ${product.currentQty} ${product.productType === 'kg' ? 'KG': ''}
                    </span>
                    <div class="cart_product_action">                        
                        <div class="product_data" data-type="${product.productType}"
                        data-inc-qty="${product.productIncVal}"></div>
                        <a href="javascript:void(0)" class="remove-product js-remove-product-from-cart js-cart-action" data-action="delete">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19 7L18.1327 19.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224C6.81296 21 5.94208 20.1891 5.86732 19.1425L5 7" stroke="#D5D7DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M8.5 7V4.5C8.5 3.67157 9.17157 3 10 3H14C14.8284 3 15.5 3.67157 15.5 4.5V7" stroke="#D5D7DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M20.5 7H3.5" stroke="#D5D7DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </a>
                        
                        <div class="product_qty_action">
                            <a href="javascript:void(0)" class="product_act_button js-dec-product-qty js-cart-action" data-action="decrease">
                                <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.5 1H14.5" stroke="white" stroke-width="2" stroke-linecap="round"></path>
                                </svg>
                            </a>
                            
                            <span class="product-qty-in-cart" id="product-qty-in-cart">
                                ${product.currentQty} ${product.productType === 'kg' ? 'KG': ''}
                            </span>
                            
                            <a href="javascript:void(0)" class="product_act_button js-inc-product-qty js-cart-action" data-action="add">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0002 3.19922C10.3185 3.19922 10.6237 3.32565 10.8487 3.55069C11.0738 3.77573 11.2002 4.08096 11.2002 4.39922V8.79922H15.6002C15.8984 8.79921 16.1859 8.91022 16.4067 9.11062C16.6275 9.31101 16.7658 9.58643 16.7946 9.88322L16.8002 9.99922C16.8002 10.3175 16.6738 10.6227 16.4487 10.8477C16.2237 11.0728 15.9185 11.1992 15.6002 11.1992H11.2002V15.5992C11.2002 15.8974 11.0892 16.1849 10.8888 16.4057C10.6884 16.6265 10.413 16.7648 10.1162 16.7936L10.0002 16.7992C9.68194 16.7992 9.37671 16.6728 9.15167 16.4477C8.92662 16.2227 8.8002 15.9175 8.80019 15.5992V11.1992H4.4002C4.10201 11.1992 3.81451 11.0882 3.59371 10.8878C3.37291 10.6874 3.23462 10.412 3.2058 10.1152L3.2002 9.99922C3.2002 9.68096 3.32662 9.37573 3.55167 9.15069C3.77671 8.92565 4.08194 8.79922 4.4002 8.79922H8.80019V4.39922C8.80019 4.10104 8.9112 3.81354 9.11159 3.59273C9.31199 3.37193 9.58741 3.23364 9.88419 3.20482L10.0002 3.19922Z" fill="white"></path>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>`;
        
        $(SETTINGS.selectors.cartContainer).append(html);
    };

    // --- Checkout Summary Updater ---
    const updateCheckoutSummary = (product, newQty) => {
        // 1. Target the specific container
        const $checkoutContainer = $('.checkout_page .order_details .products');
        
        // If not on checkout page, stop.
        if ($checkoutContainer.length === 0) return;

        // 2. Find the specific row by matching the Title (h4)
        // We filter through .product divs to find the one with the matching title
        const $summaryItem = $checkoutContainer.find('.product').filter(function() {
            const itemTitle = $(this).find('.product_details h4').text().trim();
            return itemTitle === product.title;
        });

        // If item isn't in the list, stop.
        if ($summaryItem.length === 0) return;

        // 3. Update Logic
        if (newQty <= 0) {
            // REMOVE: If qty is 0, remove the whole row
            $summaryItem.remove();
        } else {
            // UPDATE: Target strict path -> .product_qty span            
            const qtyText = product.productType === 'kg' ? `${parseFloat(newQty).toFixed(2)} KG` : newQty;
            $summaryItem.find('.product_qty .default_qty').text(qtyText);
            $summaryItem.find('.product_qty .product-qty-in-cart').text(qtyText);

            // OPTIONAL: Update the line price (Unit Price * Qty) so the summary is accurate
            // const totalLinePrice = (newQty > 1) ? (product.normalPrice / (newQty - 1)) * newQty : product.normalPrice;
            // $summaryItem.find('.pricing .price').text(Utils.formatMoney(totalLinePrice));
        }
    };

    // --- Update Checkout Totals (Right Sidebar) ---
    const updateOrderTotalSummary = (basketData) => {
        const $summary = $('.checkout_page .summary');
        if ($summary.length === 0 || !basketData) return;
    
        // 1. Update "X items" (Total number of items, e.g., 6)
        // const $itemsSpan = $summary.find('.summary_row.sub_total').find('.left span');
        // $itemsSpan.text(`${basketData.num_items} items`);
    
        // 2. Update Subtotal 
        const $subtotalCost = $summary.find('.summary_row.sub_total').find('.right .cost');
        $subtotalCost.text(Utils.formatMoney(basketData.total_incl_tax_excl_discounts));
    
        // 3. Update Shipping (If you have a shipping row, usually the second row)
        const $shippingCost = $summary.find('.summary_row.delivery_fee').find('.right .cost');
        if ($shippingCost.length > 0) {
            $shippingCost.text(Utils.formatMoney(basketData.shipping_charge));
        }
    
        // 4. Update Grand Total (total_incl_tax)
        let $totalCost = $summary.find('.summary_row.total').find('.right .cost');
        $totalCost.text(Utils.formatMoney(basketData.order_total));
    };

    // --- Core Logic ---
    const handleBasketRequest = (product, product_type, action, product_inc_value) => {
        let method = 'POST';
        let url = SETTINGS.urls.add(product.id);
        
        if (action === 'decrease') {
            method = 'DELETE';
            url = SETTINGS.urls.remove(product.id); 
        } else if (action === 'delete') {
            method = 'DELETE';
            url = SETTINGS.urls.delete(product.id);
        }

        $.ajax({
            method: method,
            url: url,
            headers: {'X-CSRFToken': csrf_token}, 
        }).done(function(data) {
            let currentQty = Number(product.currentQty);
            let newQty = currentQty;

            // 1. Calculate the NEW quantity of the specific item being clicked
            if (action === 'add') {
                newQty = currentQty + Number(product_inc_value);                
                renderCartItem(product);
            } else if (action === 'decrease') {
                newQty = Math.max(0, currentQty - Number(product_inc_value));;
            } else if (action === 'delete') {
                newQty = 0;
            }

            if (newQty <= 0) {
                 $(`.cart_inner .product[data-product-id="${product.id}"]`).remove();
            }

            // Sync UI
            syncProductState(product.id, newQty, product_type);
            updateGlobalTotals(data.basket.total_incl_tax, data.basket.num_lines);

            // Update Checkout Product List
            updateCheckoutSummary(product, newQty);

            // Update Checkout Totals (The NEW function)
            updateOrderTotalSummary(data.basket);

            // --- TOAST LOGIC (NEW) ---
            // Check if origin is NOT the cart (length 0 means it's grid, hero, or wishlist)
            const isCartAction = product.element.closest('.cart_inner').length > 0;

            if (!isCartAction) {
                let toastMsg = '';
                if (action === 'add') {
                    // It might be a new add or just an increment
                    toastMsg = `<h4 class="red">Product Added!</h4><p>${product.title} added to cart.</p>`;
                } else if (action === 'decrease') {
                    if (newQty === 0) {
                        toastMsg = `<h4 class="red">Product Removed!</h4><p>${product.title} removed from cart.</p>`;
                    } else {
                        toastMsg = `<h4 class="red">Product Updated!</h4><p>${product.title} quantity reduced.</p>`;
                    }
                } else if (action === 'delete') {
                    toastMsg = `<h4 class="red">Product Removed!</h4><p>${product.title} removed from cart.</p>`;
                }

                if (toastMsg && typeof showToast === 'function') {
                    showToast(toastMsg);
                }
            }
        }).fail(function(xhr) {
            // 1. Extract the error message
            let errorMsg = "Something went wrong. Please try again.";
            
            if (xhr.responseJSON && xhr.responseJSON.message) {
                errorMsg = xhr.responseJSON.message;
            } else if (xhr.responseText) {
                // Fallback for non-JSON errors
                errorMsg = xhr.statusText;
            }
        
            // 2. Display the toast to the user
            if (typeof showToast === 'function') {
                showToast(`<h4 class="red">Error</h4><p>${errorMsg}</p>`);
            }
        });
    };

    // --- Event Listeners ---

    // 1. Unified Cart Action Listener (Handles Add, Dec, Remove for both Card and Cart)
    // Note: I added class 'js-cart-action' and data-attribute 'data-action' to your buttons 
    // effectively merging .js-add-to-cart, .js-inc-product-qty, .js-dec-product-qty etc.
    // Use the existing selectors + the new unified logic:
    
    const actionSelectors = [
        '.js-add-to-cart',          // Card Add
        '.js-add-to-cart-inc',      // Card Add (Inc)
        '.js-inc-product-qty',      // Cart Inc
        '.js-reduce-from-cart',     // Card Dec
        '.js-dec-product-qty',      // Cart Dec
        '.js-remove-product-from-cart', // Cart Delete
        '.js-remove-product-from-checkout', //Checkout delete
        '.js-dec-product-qty-checkout', //Checkout Dec
        '.js-inc-product-qty-checkout', //Checkout Inc
    ].join(', ');

    $(document).on('click', actionSelectors, function(e) {
        e.preventDefault();
        const $btn = $(this);
        const product = Utils.getProductDetails($btn);
        
        // 1. Go up to the container, then find the data div
        const $container = $btn.closest('.product_action, .product_actions, .cart_product_action, .product_buttons, .product_qty_action, .product_action_mobile');
        const $productData = $container.find('.product_data');

        const product_type = $productData.attr('data-type');
        const product_inc_value = product_type === 'kg' ? parseFloat($productData.attr('data-inc-qty')).toFixed(2) : 1;
        // Determine Action
        let action = 'add'; // Default
        // STRICT CHECK:
        // If it is the "Reduce" button (Grid or Cart), it is ALWAYS 'decrease'
        if ($btn.hasClass('js-reduce-from-cart') || $btn.hasClass('js-dec-product-qty') || $btn.hasClass('js-dec-product-qty-checkout') || $btn.data('action') === 'decrease') {
            action = 'decrease'; 
        } 
        // Only the "Trash" icon triggers 'delete'
        else if ($btn.hasClass('js-remove-product-from-cart') || ($btn.hasClass('js-remove-product-from-checkout')) || $btn.data('action') === 'delete') {
            action = 'delete';   
        }
        handleBasketRequest(product, product_type, action, product_inc_value);
    });

    // 2. Mobile Interactions (Kept mostly as is)
    $(document).on('click touchstart', '.product_card .product_action_mobile .js-inc-product-qty', function(e) {
        e.preventDefault(); e.stopPropagation();
        $('.product_action_mobile').removeClass('show_buttons');
        $(this).closest('.product_action_mobile').addClass('show_buttons');
    });

    $(document).on('click touchstart', function(e) {
        if (!$(e.target).closest('.product_card').length) {
            $('.product_action_mobile').removeClass('show_buttons');
        }
    });

    // 3. Login Toast
    $('.js-show-login-toast').on('click', function(e){
        e.preventDefault();
        showToast(`<h4 class="red">Login Required!</h4><p>Login required to add items to cart.</p>`);
    });

    // 4. Re-Order Functionality
    $(document).on('click', '.js-reorder', function(e) {
        e.preventDefault();
        const orderId = $(this).data('order-id');

        if (!orderId) return;

        $.ajax({
            method: 'POST',
            url: SETTINGS.urls.reorder(orderId),
            headers: {'X-CSRFToken': csrf_token},
        }).done(function() {
            if (typeof showToast === 'function') {
                showToast(`<h4 class="red">Success!</h4><p>Items from Order #${orderId} added to cart.</p>`);
            }
            // Reload to update cart totals/UI
            setTimeout(() => window.location.reload(), 1000);
        }).fail(function() {
            if (typeof showToast === 'function') {
                showToast(`<h4 class="red">Error!</h4><p>Could not re-order items.</p>`);
            }
        });
    });

    // --- ON LOAD SYNC ---
    // Loop through items already in the cart sidebar on page load 
    // and sync their quantities to the Product Hero and Grid.
    // if ($(SETTINGS.selectors.cartContainer).find('.product').length > 0) {
    //     $(SETTINGS.selectors.cartContainer).find('.product').each(function() {
    //         // We use the Utils we created earlier to grab the data safely
    //         const product = Utils.getProductDetails($(this));
            
    //         // Force the Hero/Grid to match the Cart's quantity
    //         syncProductState(product.id, product.currentQty);
    //     });
    // } 

    $(document).on('click', '.js-buy-selected-ingredients', function(e){
        e.preventDefault();
    
        const ingredients = {
            "items": []
        };
    
        // Find each recipe-product that is currently selected
        $('.buy_recipe_ingredients .recipe-product.selected-ingredient').each(function() {
            const $this = $(this);            
            const productId = $this.data('product-id');             
            const quantity = $this.find('.update-product-qty').text().trim();            
            let cleanQty = quantity.replace(/[a-zA-Z]/g, '').trim();
            const currentQty = parseFloat(cleanQty) || 0;
    
            if (productId) {
                ingredients.items.push({
                    "product_id": productId,
                    "quantity": currentQty
                });
            }
        });
    
        // console.log('Selected Ingredients:', ingredients);
        $.ajax({
            url: '/api/basket/add-bulk',
            type: 'POST',
            headers: {
                'accept': 'application/json'
            },
            contentType: 'application/json',
            data: JSON.stringify(ingredients),
            success: function(response) {
                showToast(`<h4 class="red">Basket Updated</h4><p>Ingredients added successfully.</p>`);
                setTimeout(() => {
                    location.reload(true);
                }, 300);
            },
            error: function(xhr) {
                console.error('Bulk add error:', xhr.responseText);
                showToast(`<h4 class="red">Error</h4><p>Failed to add items to basket.</p>`);
            }
        });
    }).on('click', '.js-inc-ingredient-qty, .js-dec-ingredient-qty', function(e) {
        e.preventDefault();
        
        const $btn = $(this);
        const isIncrement = $btn.hasClass('js-inc-ingredient-qty');
        const $container = $btn.closest('.product_actions, .product_action');
        const $productData = $container.find('.product_data');
        const type = ($productData.attr('data-type') || '').toLowerCase();
        
        // Convert to Number immediately (No .toFixed here)
        const incVal = type === 'kg' ? (parseFloat($productData.attr('data-inc-qty')) || 0) : 1;
        
        const $qtyDisplay = $container.find('.update-product-qty');
        let rawQty = $qtyDisplay.text().trim();
        
        // Strip units and convert to Number (No .toFixed here)
        let cleanQty = rawQty.replace(/[a-zA-Z]/g, '').trim();
        const currentQty = parseFloat(cleanQty) || 0;
        
        let newQty;
        if (isIncrement) {
            newQty = currentQty + incVal;
        } else {
            if (currentQty <= incVal) return; 
            newQty = currentQty - incVal;
        }
        
        // Update display: apply .toFixed(2) only at the very end for the UI string
        const qtyText = type === 'kg' ? `${newQty.toFixed(2)} KG` : newQty;            
        $qtyDisplay.text(qtyText);
    });

});